import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Story } from '../../interfaces/story';
import { TranslateService } from '@ngx-translate/core';
import { StoriesService } from '../list.service';
import { SafeUrl } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import * as fromApp from '../../../app.reducer';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'story-link',
  styleUrls: ['./story-link.component.scss'],
  templateUrl: './story-link.component.html',
})
export class StoryLinkComponent implements OnInit {
  @Input() story: Story;
  @Input() submitting;
  @Input() isMobilePlatform: boolean;
  @Output() clicked = new EventEmitter();
  cover: SafeUrl;
  storyError;

  constructor(
    private translate: TranslateService,
    public storiesService: StoriesService,
    private firebaseService: FirebaseService
  ) {}

  ngOnInit() {
    if (this.story) {
      this.serveStory();
    }
  }

  showModal(event) {
    this.clicked.emit(event);
  }

  serveStory() {
    if (this.story.state === 'published') {
      this.getStoryCover();
    } else if (this.story.state === 'error') {
      this.storyError = true;
    }
  }

  getStoryCover() {
    this.cover = this.story.cover_url;
    if (this.story.cover_url) {
      this.cover = this.story.cover_url;
    } else if (!this.story.cover_url) {
      const cover = this.story.spreads.find(sp => sp.spread_type === 'frontcover').urls.thumbnail;
      if (cover) {
        this.cover = cover;
      } else {
        this.storyError = true;
      }
    } else {
      this.storyError = true;
    }
  }

  isStoryReady() {
    return this.story.state === 'published' && this.cover;
  }

  isStoryFullyUploaded() {
    return this.story.hires_uploaded;
  }

  isStoryProcessing() {
    return this.story.state === 'designing' || this.story.state === 'new';
    // All states:
    // NEW = 'new'
    // DESIGNING = 'designing'
    // PUBLISHED = 'published'
    // ERROR = 'error'
    // DELETED = 'deleted'
  }

  deleteStory(event, story) {
    let message;
    event.preventDefault();
    event.stopPropagation();
    this.translate
      .get('confirm_delete_photo_story')
      .subscribe((res: string) => {
        message = res;
      });

    if (confirm(message)) {
      this.storiesService.deleteStory(story.id);
      this.firebaseService.logEvent('story_delete', {
        story_id: story.id,
        project_id: story.project.id,
      });
    }
  }

  orderStory(event, story) {
    this.firebaseService.logEvent('checkout_enter', {
      story_id: story.id,
      project_id: story.project.id,
      event_source: 'library',
    });
    event.preventDefault();
    event.stopPropagation();
  }
}
